import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Tabs } from 'antd';
import type { TabsProps } from 'antd';

import { CrudSchemaFields } from '@ohpen/enso-ui';

import { FormGeneralErrors } from '@pmp/components';
import { ProductsFormSchemaProps } from '../interfaces';

export const DETAILS_TAB = 'details';
export const ADDITIONAL_FIELDS_TAB = 'additional-fields';

export const ProductsFormSchema: FC<ProductsFormSchemaProps> = ({
  form,
  schema,
  additionalFieldsSchema,
  mode,
  readonly,
  generalErrors,
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation();

  const items: TabsProps['items'] = useMemo(() => {
    const tabs: TabsProps['items'] = [
      {
        key: DETAILS_TAB,
        label: t('pmp.products.labels.productDetails'),
        forceRender: true,
        children: (
          <Flex vertical gap={24} className="enso-ui-tab-content scroll">
            <FormGeneralErrors errors={generalErrors} />
            <CrudSchemaFields schema={schema} form={form} mode={mode} readonly={readonly} component={false} />
          </Flex>
        ),
      },
    ];

    if (additionalFieldsSchema) {
      tabs.push({
        key: ADDITIONAL_FIELDS_TAB,
        label: t('pmp.products.labels.additionalFields'),
        forceRender: true,
        children: (
          <Flex vertical gap={24} className="enso-ui-tab-content scroll">
            <CrudSchemaFields schema={[additionalFieldsSchema]} form={form} mode={mode} readonly={readonly} component={false} />
          </Flex>
        ),
      });
    }

    return tabs;
  }, [t, form, schema, additionalFieldsSchema, mode, readonly, generalErrors]);

  return (
    <div className="enso-ui-tabs-wrapper">
      <Tabs items={items} activeKey={activeTab} onChange={onTabChange} />
    </div>
  );
};
